import { APP_LOAD_COMPANY_SUCCESS, APP_LOAD_COMPANY_FAILED, APP_LOAD_USER_FAILED, APP_LOAD_USER_SUCCESS } from './../constants/main.constants'
import agent from './../../services/sportigo';

export function loadCompany() {
    return dispatch => {
        var promise = agent.Company.get();

        dispatch(request(promise));

        promise.then(res => {
            if (res.error)
                return dispatch({ type: APP_LOAD_COMPANY_FAILED, response: res });

            dispatch({ type: APP_LOAD_COMPANY_SUCCESS, company: res.company });
        })
    }
}

export function loadUser() {
    return dispatch => {
        agent.Auth.current()
            .then(res => {
                if (!res) {
                    return dispatch({ type: APP_LOAD_USER_FAILED, response: res });
                }

                if (res.status && res.status == 'error') {
                    return dispatch({ type: APP_LOAD_USER_FAILED, response: res });
                }

                if (res.error)
                    return dispatch({ type: APP_LOAD_USER_FAILED, response: res });

                dispatch({ type: APP_LOAD_USER_SUCCESS, member: res.member });
            })
    }
}

export function request(promise) {
    return { type: 'GENERIC_REQUEST', payload: promise };
}